/**
 * Utilidades para manejar la información del usuario en localStorage
 */

const USER_INFO_KEY = 'ravcell_user_info';

/**
 * Guarda la información del usuario en localStorage
 * @param {Object} userInfo - Información del usuario
 */
export const saveUserInfo = (userInfo) => {
  if (userInfo) {
    try {
      const userInfoStr = JSON.stringify(userInfo);
      localStorage.setItem(USER_INFO_KEY, userInfoStr);
    } catch (error) {
      console.error('Error al guardar información en localStorage:', error);
    }
  }
};

/**
 * Obtiene la información del usuario desde localStorage
 * @returns {Object|null} - Información del usuario o null si no existe
 */
export const getUserInfo = () => {
  try {
    const userInfoStr = localStorage.getItem(USER_INFO_KEY);

    if (userInfoStr) {
      return JSON.parse(userInfoStr);
    }
  } catch (error) {
    console.error('Error al obtener información de localStorage:', error);
  }
  return null;
};

/**
 * Verifica si el usuario tiene un permiso específico
 * @param {string} permission - Permiso a verificar
 * @returns {boolean} - true si tiene el permiso, false en caso contrario
 */
export const hasPermission = (permission) => {
  const userInfo = getUserInfo();

  if (!userInfo?.json_rol?.Statement) {
    return false;
  }

  const hasPermission = userInfo.json_rol.Statement.some(
    (statement) =>
      statement.Action &&
      Array.isArray(statement.Action) &&
      statement.Action.includes(permission),
  );

  return hasPermission;
};

/**
 * Verifica si el usuario tiene permiso para aceptar pagos
 * @returns {boolean}
 */
export const hasPaymentPermission = () => {
  return hasPermission('front_payments_insert:addOperation') || hasPermission('*:*');
};
